<template>
  <div class="home">
    <appHeader :userInfo="userInfo"></appHeader>
    <router-view @user="getUserInfo"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {}
    }
  },
  methods: {
    getUserInfo(e){
      this.userInfo = e
    }
  }
}

</script>

<style scoped lang="scss">

</style>
